import { StyleSheet } from 'react-native';
import { text } from 'src/theme/colors';

export const styles = StyleSheet.create({
  leftAction: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 4,
    justifyContent: 'flex-start',
  },
  leftActionIcon: {
    width: 22,
    height: 22,
    padding: 2,
  },

  leftActionText: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: text.color.interactive,
  },
});
